import React, { memo, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  handleActiveAttachment,
  handleOpenTab,
} from "../../../../../store/attachmentsInteraction/actions";
import Accordion from "../../../Accordion";
import AttachmentItem from "../../../AttachmentItem";
import axios from "axios";
import "../../style.scss";

function AccordionsSubComponent({ activeChat }) {
  const dispatch = useDispatch();

  const { openTab, list } =
    useSelector((state) => state.AttachmentsInteraction?.[activeChat]) || {};

  const {
    new: newAttachments,
    approved: approvedAttachments,
    rejected: rejectedAttachments,
    sent: sentAttachments,
    requested: requestedAttachments,
  } = list || {};

  const handleToggle = useCallback(
    (value) => {
      dispatch(handleOpenTab(activeChat, value));
    },
    [activeChat, dispatch]
  );

  return (
    <>
      <Accordion
        title="New"
        isOpen={openTab?.new}
        value="new"
        toggle={handleToggle}
      >
        <Attachments type="new" data={newAttachments} activeChat={activeChat} />
      </Accordion>
      <Accordion
        title="Approved"
        isOpen={openTab?.approved}
        value="approved"
        toggle={handleToggle}
      >
        <Attachments
          type="approved"
          data={approvedAttachments}
          activeChat={activeChat}
        />
      </Accordion>
      <Accordion
        title="Rejected"
        isOpen={openTab?.rejected}
        value="rejected"
        toggle={handleToggle}
      >
        <Attachments
          type="rejected"
          data={rejectedAttachments}
          activeChat={activeChat}
        />
      </Accordion>
      <Accordion
        title="Requested"
        isOpen={openTab?.requested}
        value="requested"
        toggle={handleToggle}
      >
        <Attachments
          type="requested"
          data={requestedAttachments}
          activeChat={activeChat}
        />
      </Accordion>
      <Accordion
        title="Sent"
        isOpen={openTab?.sent}
        value="sent"
        toggle={handleToggle}
      >
        <Attachments
          type="sent"
          data={sentAttachments}
          activeChat={activeChat}
        />
      </Accordion>
    </>
  );
}

export default memo(AccordionsSubComponent);

const Attachments = memo(({ type, data, activeChat }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  const isOperatorArea = history.location.pathname === "/chats";

  const { activeAttachment } =
    useSelector((state) => state.AttachmentsInteraction?.[activeChat]) || {};

  const handleClick = useCallback(
    (data) => {
      if (isOperatorArea) return;

      const token = JSON.parse(localStorage.getItem("authUser"));
      axios.post(`${process.env.REACT_APP_MESSAGES_API_URL}/log/file`, { 
        fileUrl: data?.files?.file_url,
        fileName: data?.files?.file_name,
        action: 'view'
      }, {
        headers: {
          Authorization: token.Authorization
        }
      })

      dispatch(handleActiveAttachment(activeChat, data));
    },
    [activeChat, dispatch, isOperatorArea]
  );

  return (
    <div className="d-flex flex-column p-2" style={{ gap: 10 }}>
      {!data?.length && (
        <div className="d-flex justify-content-center align-items-center no-data">
          <i className="fas fa-file-alt mr-2" />
          <span className="text-muted">{t("No matching records found")}</span>
        </div>
      )}

      {data?.map((item) => (
        <AttachmentItem
          key={item.id}
          type={type}
          data={item}
          active={activeAttachment?.id === item.id && !isOperatorArea}
          onClick={handleClick}
        />
      ))}
    </div>
  );
});
